import { useCallback, useEffect, useState } from 'react'
import { getRoomById } from 'ducks/chat/utils/rooms'

export function useMatrixRoomById(roomId) {
  const [loadedRoom, setLoadedRoom] = useState(null)

  const loadRoom = useCallback(
    async () => {
      if (loadedRoom) return
      const room = await getRoomById(roomId)
      setLoadedRoom(room)
    },
    [loadedRoom, roomId]
  )

  useEffect(
    () => {
      loadRoom()
    },
    [loadRoom]
  )

  return loadedRoom
}
